module.exports = __webpack_public_path__ + "static/media/calendar-contest.30bef42a.svg";